import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MyCartsRoutingModule } from './my-carts-routing.module';
import { MyCartsComponent } from './my-carts.component';
import { AdsModule } from '../adcomponents/ad.module';
import { WatchListComponent } from './watch-list/watch-list.component';
import { CartSummaryComponent } from './cart-list/cart-summary/cart-summary.component';
import { CartListComponent } from './cart-list/cart-list.component';
import { ProductDetailComponent } from '../product/productdetail/product.detail.component';
import { NgProgressModule } from 'ngx-progressbar';
import { ProductDetailModule } from '../product/product.detail.module';
import { CartSearchComponent } from './cart-list/cart-search/cart-search.component';
import { NotificationWatchlistComponent } from './watch-list/notification-watchlist/notification-watchlist.component';
import { UploadToCartComponent } from './cart-list/cart-summary/upload-to-cart/upload-to-cart.component';
import { SendCartToSalesComponent } from './cart-list/cart-summary/send-cart-to-sales/send-cart-to-sales.component';
import { ShippingAddressComponent } from './check-out/shipping-address/shipping-address.component';
import { FreightShipMethodComponent } from './check-out/freight-ship-method/freight-ship-method.component';
import { PaymentComponent } from './check-out/payment/payment.component';
import { SummaryOrderComponent } from './check-out/summary-order/summary-order.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Ng2CompleterModule } from 'ng2-completer';
import { TenantComponent } from './check-out/tenant/tenant.component';
import { EndUserComponent } from './check-out/end-user/end-user.component';
import { BuyPageModule } from '../buy/buy.page.module';
import { CspTenantComponent } from './check-out/tenant/csp-tenant/csp-tenant.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { SharedModule } from '../shared/shared.module';
import { DeliverySummaryComponent } from './check-out/summary-order/delivery-summary/delivery-summary.component';
import { PaymentSummaryComponent } from './check-out/summary-order/payment-summary/payment-summary.component';
import { PartshipSummaryComponent } from './check-out/summary-order/partship-summary/partship-summary.component';
import { ItemSummaryComponent } from './check-out/summary-order/item-summary/item-summary.component';
import { OrderConfirmationComponent } from './check-out/order-confirmation/order-confirmation.component';
import { SelectLocationComponent } from './check-out/shipping-address/select-location/select-location.component';
import { TermsAndConditionsComponent } from '../popup-collection/terms-and-conditions/terms-and-conditions.component';
import { SelectEndUserComponent } from './check-out/end-user/select-end-user/select-end-user.component';
import { MatSortModule } from '@angular/material/sort';
import { MicrosoftCloudAgreementComponent } from '../popup-collection/microsoft-cloud-agreement/microsoft-cloud-agreement.component';
import { FinanceModule } from '../finance/finance.module';
import { CheckOutComponent } from './check-out/check-out.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { DonationComponent } from './check-out/donation/donation.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ChildHeaderModule } from '../child-header/child-header.module';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTableModule } from '@angular/material/table';
import { MatInputModule } from '@angular/material/input';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import {MatCardModule} from '@angular/material/card';
import { BreadcrumbModule } from '../breadcrumb/breadcumb.module';

@NgModule({
    imports: [
        CommonModule, 
        ProductDetailModule, 
        NgProgressModule,
        FormsModule, 
        ReactiveFormsModule, 
        MyCartsRoutingModule, 
        AdsModule, 
        NgbModule, 
        Ng2CompleterModule, 
        BuyPageModule, 
        NgxPaginationModule, 
        MatAutocompleteModule, 
        MatFormFieldModule, 
        MatTableModule, 
        MatInputModule, 
        SharedModule, 
        MatDividerModule, 
        MatCardModule, 
        MatIconModule, 
        MatSelectModule, 
        MatCheckboxModule, 
        MatDialogModule, 
        MatSlideToggleModule, 
        MatSortModule, 
        FinanceModule,
        NgSelectModule,
        MatProgressSpinnerModule,
        ChildHeaderModule,
        MatButtonModule,
        BreadcrumbModule
    ],
    declarations: [
        MyCartsComponent,
        WatchListComponent,
        CartSummaryComponent,
        CartListComponent,
        CartSearchComponent,
        NotificationWatchlistComponent,
        UploadToCartComponent,
        SendCartToSalesComponent,
        ShippingAddressComponent,
        FreightShipMethodComponent,
        PaymentComponent,
        SummaryOrderComponent,
        TenantComponent,
        EndUserComponent,
        CspTenantComponent,
        DeliverySummaryComponent,
        PaymentSummaryComponent,
        PartshipSummaryComponent,
        ItemSummaryComponent,
        OrderConfirmationComponent,
        SelectLocationComponent,
        SelectEndUserComponent,
        CheckOutComponent,
        DonationComponent,
        TermsAndConditionsComponent,
        MicrosoftCloudAgreementComponent
    ],
    entryComponents: [ProductDetailComponent, TermsAndConditionsComponent, MicrosoftCloudAgreementComponent],
    providers: []
})
export class MyCartsModule { }
